import { API_BASE_URL } from '@/constants/api-endpoints.constants';
import { getData, postData, putData } from '@/lib/axios';
import { userPayload } from './types';

export const fetchUser = async () => {
  try {
    const url = `${API_BASE_URL}/console/v1/users`;

    const response = await getData(url);

    return {
      status: true,
      usersData: response?.data || [],
      totalCount: response?.totalCount || 0,
      error: '',
    };
  } catch (err) {
    return {
      status: false,
      error: err,
    };
  }
};

export const fetchSingleUser = async (userId?: string) => {
  try {
    const response = await getData(
      `${API_BASE_URL}/console/v1/users/${userId}`
    );

    if (response?.data) {
      return {
        status: true,
        usersData: response?.data?.[0],
        error: '',
      };
    }
  } catch (err) {
    console.error(err)
    return {
      status: false,
      error: err,
    };
  }
};

export const updateUserStatus = async (enabled: boolean, userId: string) => {
  try {
    const url = `${API_BASE_URL}/console/v1/users/${userId}`;
    const data = {
      enabled: enabled,
      statusUpdateOnly: 'yes',
    };
    await putData(url, data);
  } catch (err) {
    return {
      status: false,
      error: err,
    };
  }
};

export const addUser = async (
  usersData: userPayload
) => {
  try {
    const url = `${API_BASE_URL}/console/v1/users`;
    await postData(url, usersData);
    return {
      status: true,
      error: '',
    };
  } catch (err) {
    return {
      status: false,
      error: err,
    };
  }
};

export const updateUser = async (
  userId: string | undefined,
  usersData: userPayload
) => {
  try {
    const url = `${API_BASE_URL}/console/v1/users/${userId}`;

    await putData(url, usersData);

    return {
      status: true,
      error: '',
    };
  } catch (err) {
    return {
      status: false,
      error: err,
    };
  }
};


export const fetchPermission =  async (id?: string) => {
  try {
    
    const URL = `${import.meta.env.VITE_API_GATEWAY_BASE_URL}/console/v1/users/${id}/permissions`
    const response = await getData(URL)
    return {
      status: true,
      permissions: response,
      error: ""
    }
  } catch(err) {
    return {
      status: false,
      error: err,
    }; 
  }
}